(() => {
  const desktopQuery = window.matchMedia('(min-width: 1024px)');
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener(
    'click',
    (event) => {
      const toggle = event.target.closest('[data-sidebar-toggle]');
      if (!toggle) return;
      if (!desktopQuery.matches || motionQuery.matches) return;
      if (typeof document.startViewTransition !== 'function') return;

      const root = toggle.closest('[data-reduce-columns-on-filter]');
      if (!root) return;

      const sidebar = root.querySelector('[data-filter-sidebar]');
      if (!sidebar) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const update = () => {
        const isHidden = sidebar.getAttribute('aria-hidden') === 'true';

        if (isHidden) {
          toggle.setAttribute('aria-expanded', 'true');
          sidebar.setAttribute('aria-hidden', 'false');
          if (sidebar.classList.contains('animation--filter-sidebar')) {
            sidebar.classList.add('animation--filter-sidebar-revealed');
          }
        } else {
          toggle.setAttribute('aria-expanded', 'false');
          sidebar.setAttribute('aria-hidden', 'true');
          sidebar.classList.remove('animation--filter-sidebar-revealed');
        }
      };

      root.classList.add('is-filter-layout-transitioning');

      let transition;

      try {
        transition = document.startViewTransition({
          update,
          types: ['collection-filter-layout'],
        });
      } catch (error) {
        transition = document.startViewTransition(update);
      }

      Promise.resolve(transition && transition.finished).finally(() => {
        root.classList.remove('is-filter-layout-transitioning');
      });
    },
    true
  );
})();
